import script from "./MyRedemptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyRedemptions.vue?vue&type=script&setup=true&lang=ts"

import "./MyRedemptions.vue?vue&type=style&index=0&id=de40e4f2&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de40e4f2"]])

export default __exports__